import instance from "./request";

// 获取验证码请求
export const GetCaptchaCodeApi = () => instance.get("/admin/captchaImage")

// 登录请求
export const LoginApi = (params) => instance.post("/admin/login", params)

// 获取路由请求
export const GetUserRoutersApi = () => instance.get("/admin/getRouters")

// 获取用户信息
export const GetUserInfoApi = () => instance.get("/admin/getInfo")

// 获取通知
export const GetNoticeApi = (params) => instance.get("/admin/getNotice", params)
// 发布通知
export const SubmitNoticeApi = (params) => instance.post("/admin/notice/update", params)

// 用户查询
export const GetUsersApi = (params) => instance.get("/admin/getUsers", params)
// 修改期限
export const UserChangeTermApi = (params) => instance.post("/admin/user/changeTerm", params)
// 充值
export const UserChargeApi = (params) => instance.post("/admin/user/charge", params)

// 积分扣减
export const UserCutApi = (params) => instance.post("/admin/user/cut", params)
// 注销
export const UserDelApi = (params) => instance.post("/admin/user/del", params)
// 解绑
export const UserUnbindApi = (params) => instance.post("/admin/user/unbind", params)
// 修改密码
export const UserChangePwdApi = (params) => instance.post("/admin/user/changePwd", params)
// 注册
export const UserRegisterApi = (params) => instance.post("/admin/user/register", params)
// 解封IP
export const UnfreezeIpApi = (params) => instance.post("/admin/ip/unfreeze/cover", params)
// IP加白名单
export const WhiteIpApi = (params) => instance.post("/admin/ip/white", params)
// 改收款码顺序
export const ChangePayOrderApi = (params) => instance.post("/admin/settings/pay/order", params)
// 改微信赞赏码
export const ChangeWxCodeApi = (params) => instance.post("/admin/settings/pay/wx", params)


// 批量续期
export const UserPlChangeTermApi = (params) => instance.post("/admin/user/plChangeTerm", params)
// 查询单个代理信息
export const GetAgentApi = (params) => instance.get("/admin/agent/user/search", params)
// 添加代理
export const AddAgentApi = (params) => instance.post("/admin/agent/add", params)
// 删除代理
export const DelAgentApi = (params) => instance.post("/admin/agent/del", params)
// 查询软件
export const GetSoftsApi = (params) => instance.get("/admin/agent/soft/search", params)
// 修改软件
export const AlterSoftApi = (params) => instance.post("/admin/agent/soft/alter", params)
// 添加软件
export const AddSoftApi = (params) => instance.post("/admin/agent/soft/add", params)
// 删除软件
export const DelSoftApi = (params) => instance.post("/admin/agent/soft/del", params)
// 创建激活码
export const ActivateApi = (params) => instance.post("/admin/agent/code/create", params)
// 查询激活记录
export const GetLogsApi = (params) => instance.get("/admin/agent/logs/search", params)
// 查询今日激活记录
export const GetTodayLogsApi = (params) => instance.get("/admin/agent/logs/today")
// 删除激活记录
export const DelLogApi = (params) => instance.post("/admin/agent/log/del", params)
// 查询软件白名单
export const GetWhiteSoftsApi = (params) => instance.get("/admin/whiteSoft/search", params)
// 删除白名单软件
export const DelWhiteSoftApi = (params) => instance.post("/admin/whiteSoft/del", params)
// 添加白名单软件
export const AddWhiteSoftApi = (params) => instance.post("/admin/whiteSoft/add", params)
// 修改白名单软件
export const AlterWhiteSoftApi = (params) => instance.post("/admin/whiteSoft/alter", params)
// 查询软件价格表
export const GetSoftPriceApi = (params) => instance.get("/admin/softPrice/search", params)
// 删除价格表软件
export const DelSoftPriceApi = (params) => instance.post("/admin/softPrice/del", params)
// 添加价格表软件
export const AddSoftPriceApi = (params) => instance.post("/admin/softPrice/add", params)
// 修改价格表软件
export const AlterSoftPriceApi = (params) => instance.post("/admin/softPrice/alter", params)
// 上传闲置群二维码图片（单个）
export const UploadIdleCodeApi = (params) => instance.post("/admin/idlecode/upload", params)
// 批量上传闲置群二维码图片
export const BatchUploadIdleCodeApi = (params) => instance.post("/admin/idlecode/batchUpload", params)
